"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _roundConstants = _interopRequireDefault(require("./round-constants"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var iota = function iota(_ref) {
  var A = _ref.A,
      roundIndex = _ref.roundIndex;
  var i = roundIndex * 2;
  A[0] ^= _roundConstants["default"][i];
  A[1] ^= _roundConstants["default"][i + 1];
};

var _default = iota;
exports["default"] = _default;